import { getBooleanEncoder, getBytesEncoder, getDataEnumCodec, getOptionEncoder, getStringEncoder, getStructEncoder, getTupleEncoder, getU64Encoder, mapEncoder, } from '@solana/codecs';
import { splDiscriminate } from '@solana/spl-type-length-value';
import { SystemProgram, TransactionInstruction } from '@solana/web3.js';
import { getFieldCodec, getFieldConfig } from './field.js';
function getInstructionEncoder(discriminator, dataEncoder) {
    return mapEncoder(getTupleEncoder([getBytesEncoder(), dataEncoder]), (data) => [
        discriminator,
        data,
    ]);
}
function getPublicKeyEncoder() {
    return mapEncoder(getBytesEncoder({ size: 32 }), (publicKey) => publicKey.toBytes());
}
export function createInitializeInstruction(args) {
    const { programId, metadata, updateAuthority, mint, mintAuthority, name, symbol, uri } = args;
    return new TransactionInstruction({
        programId,
        keys: [
            { isSigner: false, isWritable: true, pubkey: metadata },
            { isSigner: false, isWritable: false, pubkey: updateAuthority },
            { isSigner: false, isWritable: false, pubkey: mint },
            { isSigner: true, isWritable: false, pubkey: mintAuthority },
        ],
        data: Buffer.from(getInstructionEncoder(splDiscriminate('spl_token_metadata_interface:initialize_account'), getStructEncoder([
            ['name', getStringEncoder()],
            ['symbol', getStringEncoder()],
            ['uri', getStringEncoder()],
        ])).encode({ name, symbol, uri })),
    });
}
export function createUpdateFieldInstruction(args) {
    const { programId, metadata, updateAuthority, field, value } = args;
    return new TransactionInstruction({
        programId,
        keys: [
            { isSigner: false, isWritable: true, pubkey: metadata },
            { isSigner: true, isWritable: false, pubkey: updateAuthority },
        ],
        data: Buffer.from(getInstructionEncoder(splDiscriminate('spl_token_metadata_interface:updating_field'), getStructEncoder([
            ['field', getDataEnumCodec(getFieldCodec())],
            ['value', getStringEncoder()],
        ])).encode({ field: getFieldConfig(field), value })),
    });
}
export function createRemoveKeyInstruction(args) {
    const { programId, metadata, updateAuthority, key, idempotent } = args;
    return new TransactionInstruction({
        programId,
        keys: [
            { isSigner: false, isWritable: true, pubkey: metadata },
            { isSigner: true, isWritable: false, pubkey: updateAuthority },
        ],
        data: Buffer.from(getInstructionEncoder(splDiscriminate('spl_token_metadata_interface:remove_key_ix'), getStructEncoder([
            ['idempotent', getBooleanEncoder()],
            ['key', getStringEncoder()],
        ])).encode({ idempotent, key })),
    });
}
export function createUpdateAuthorityInstruction(args) {
    const { programId, metadata, oldAuthority, newAuthority } = args;
    return new TransactionInstruction({
        programId,
        keys: [
            { isSigner: false, isWritable: true, pubkey: metadata },
            { isSigner: true, isWritable: false, pubkey: oldAuthority },
        ],
        data: Buffer.from(getInstructionEncoder(splDiscriminate('spl_token_metadata_interface:update_the_authority'), getStructEncoder([['newAuthority', getPublicKeyEncoder()]])).encode({ newAuthority: newAuthority ?? SystemProgram.programId })),
    });
}
export function createEmitInstruction(args) {
    const { programId, metadata, start, end } = args;
    return new TransactionInstruction({
        programId,
        keys: [{ isSigner: false, isWritable: false, pubkey: metadata }],
        data: Buffer.from(getInstructionEncoder(splDiscriminate('spl_token_metadata_interface:emitter'), getStructEncoder([
            ['start', getOptionEncoder(getU64Encoder())],
            ['end', getOptionEncoder(getU64Encoder())],
        ])).encode({ start: start ?? null, end: end ?? null })),
    });
}
//# sourceMappingURL=instruction.js.map